import { getCurrency } from "locale-currency";

export const getCurrencySymbol = (locale = "en-US") => {
  const currency = getCurrency(locale) || "USD";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  })
    .formatToParts(0)
    .find(p => p.type === "currency")?.value || "$";
};
